import { useSyncExternalStore } from 'react';
import { getToken, subscribeToToken } from './tokenAccess';
import { isAdminToken } from './claims';

// `useSyncExternalStore` may call the snapshot several times per render, and
// isAdminToken base64-decodes and JSON-parses the JWT on every call. Memoise on
// the token itself: one decode per distinct token, not one per render.
let cachedToken: string | null = null;
let cachedIsAdmin = false;

function readIsAdmin(): boolean {
  const token = getToken();
  if (token !== cachedToken) {
    cachedToken = token;
    cachedIsAdmin = isAdminToken(token);
  }
  return cachedIsAdmin;
}

/**
 * Reads the administrator claim from the current access token.
 *
 * Subscribed rather than read once: the token is replaced on silent renew and
 * cleared on `addUserUnloaded`, and an unsubscribed read left the admin gate
 * holding a stale answer. A cleared token made `RequireAdmin` fall back to
 * "Access denied" with nothing to ever re-render it, stranding an admin on that
 * message until a full reload.
 */
export function useIsAdmin(): boolean {
  return useSyncExternalStore(subscribeToToken, readIsAdmin);
}
